<template>
  <div class="tables-basic">

    <h2 class="page-title">Link Details</h2>
      <div v-if="loading" class="page-loading-container">
          <b-spinner label="Loading..." ></b-spinner>
      </div>
      <div v-else>
    <b-row>
      <b-col>
        <Widget
        >
          <b-row >
            <b-col lg="12" sm="12" xs="12">

                <table class="table table-hover" >
                    <thead>
                    <tr>
                        <th scope="col">Url</th>
                        <th scope="col">Status</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr class="spelling" v-for="(link, index) in links">
                        <td width="75%" class="link-entry">
                            <div v-if="link.redirect_status">
                                <b class=""><a :href="link.url" target="_blank" title="External Link">{{link.url}}</a></b>
                                <div  class="link-redirect">
                                Redirected to: <a :href="link.final_url" target="_blank" title="External Link">{{link.final_url}}</a>
                                </div>
                            </div>
                            <div v-else>
                                <b class=""><a :href="link.url" target="_blank" title="External Link">{{link.url}}</a></b>
                            </div>

                        </td>
                        <td width="35%" style="vertical-align:middle">
                            <div v-if="link.valid_for_status_check">
                                <div v-if="!link.checked_at"> <b-spinner label="Loading..." style="height:16px;width:16px;color:gray;font-size:8px"></b-spinner></div>
                                <b-badge v-else :variant="link.variant" v-b-tooltip.hover :title="link.error_text">{{link.final_status}}</b-badge>
                            </div>
                            <div class="link-status-redirect" v-if="link.redirect_status"><span :title="link.redirect_message">{{link.redirect_status}}</span></div>

                        </td >
                        </tr>
                    </tbody>
                </table>
                <h4>Linked From</h4>

                    <table class="table table-hover">
                        <tr v-for="(page,index) in pages" :class="{blur: user.role === 'demo' && index>=1}">
                            <template v-if="user.role === 'demo' && index>=1">
                                <td width="70%">{{page.url}}</td>
                                <td>Page Details</td>
                                <td>Locate</td>
                            </template>
                            <template v-else>
                            <td width="70%"><a :href="page.url" target="_blank" v-b-tooltip.hover title="External Link">{{page.url}}</a></td>
                            <td> <router-link :to="{ name: 'ExplorePageDetails', query: {url: page.path} }" v-b-tooltip.hover  title='Page Details' ><i class="fa fa-eye"></i> Page Details</router-link></td>
                            <td> <router-link  v-b-tooltip.hover  title='Locate on page' :to="{ name: 'ViewPage', params: {type: 'link'}, query: {page: page.url, site:activeSite.id, type: 'hello', focus: links[0].url} }"><i class="fa fa-search"></i> Locate Link</router-link></td>
                            </template>
                        </tr>
                    </table>

            </b-col>
          </b-row>
        </Widget>

      </b-col>
    </b-row>
      </div>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';
import DemoNotice from "@/components/DemoNotice/DemoNotice";

import gql from "graphql-tag";
import { mapState } from 'vuex';
import axios from "axios";
export default {
  name: 'Tables',
  components: { Widget, DemoNotice },
  apollo: {
    $subscribe: {
      websites_website: {
        query() {
          return gql`subscription getLink($linkUrl: String){
              websites_website(where: {id: {_eq: ${this.activeSite.id}}}) {
                  websites_links(where: {active: {_eq: true}, url: {_eq: $linkUrl}}, limit: 1, order_by: {id: asc}){
                      url
                      final_url
                      is_broken
                      error
                      valid_for_status_check
                      checked_at
                      final_status
                      redirect_status
                      websites_link_pages(order_by: {id: asc}, where: {websites_crawledpage: {is_latest: {_eq: true}}}, limit: 50){
                        websites_crawledpage{
                          id
                          url
                          path
                        }
                      }
                  }
              }
          }`
        },
        variables(){
          return {
            linkUrl: this.linkUrl,
          }
        },
        skip () {
          return !(this.activeSite.id && this.linkUrl) || (this.dataLoaded && this.scanStatus.completed);
        },
        result (data) {

          this.links = [];
          for (let entry of data.data.websites_website[0].websites_links){
            let redirectMessage = '';
            let finalStatus = entry.final_status;
            if (finalStatus === 0){
              finalStatus = entry.error && entry.error.type;
            }
            if (entry.redirect_status === 301 || entry.redirect_status === 308){
              redirectMessage = 'Moved Permanently'
            }
            else if (entry.redirect_status === 302 || entry.redirect_status === 307){
              redirectMessage = 'Moved Temporarily'
            }
            let variant = entry.is_broken ? 'danger' : 'success';
            if (entry.error && entry.error.type === 'Ignored'){
              variant = 'secondary';
              finalStatus = 'skipped';
              entry.error.message = 'Links from this domain cannot be checked.'
            }
            let linkEntry = {
              url: entry.url,
              final_url: entry.final_url,
              error: entry.error,
              error_text: entry.error && entry.error.message || 'Success',
              variant: variant,
              final_status: finalStatus,
              redirect_status: entry.redirect_status,
              redirect_message: redirectMessage,
              valid_for_status_check: entry.valid_for_status_check,
              checked_at: entry.checked_at,
              pages: [],
              selectedPageIndex: 0,
            };

            for (let page of entry.websites_link_pages){
                this.pages.push({
                  url: page.websites_crawledpage.url,
                  path: page.websites_crawledpage.path,
                  preview: '',
                  occurrences: '',
                })
            }
            this.links.push(linkEntry)
          }
          this.loading = false;
          this.dataLoaded = true;
        },

      },

    }
  },
  data() {
    return {
      pages: [],
      loading: true,
      dataLoaded: false,
      linkUrl: null,
      toastOptions: {
        theme: 'dark',
        position: 'bottomLeft',
      },
      links: [],
      currentPage: 2,
      numberOfPages: 1,
      pageSize: 15,
      row_selected: false,
    };
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Link Details - PageWatch.dev',
    // all titles will be injected into this template
  },
  computed: {
    ...mapState({activeSite: 'activeSite', scanStatus: "scanStatus", user: "user"}),
  },
  methods: {
    linkGen(hash) {
      if (!hash){
        hash = '';
      }
      return (pageNum) =>{
        return pageNum === 1 ? `?${hash}` : `?page=${pageNum}${hash}`
      };
    },
    mouseOver(spellingError, index){
      spellingError.selectedPageIndex = index;
    },
  },
  watch: {
    'activeSite': function () {
      this.dataLoaded = false;
    }
  },
  created() {
        this.$watch("$route",() => {
          this.linkUrl = this.$route.query.url || 1;
          this.dataLoaded = false;
          }, {
      immediate: true
    });
  }
};
</script>

<style src="./LinkDetails.scss" lang="scss" scoped />
<style lang="scss">
    .link-redirect {
        font-size:9pt;
        color:gray;
        padding:4px;
    }
    .link-status-redirect{
        color:red;
        font-size:9pt;
        padding:4px;
    }
    .link-entry{
        max-width:580px;
        overflow:auto;
    }
    .broken-link-preview-image {
        border-radius: 50%;
        max-width: 250px;
        box-shadow: #bdc4e0 0px 0px 20px;
    }
</style>
